// file: src/hooks/useFileDataCache.js
import { useState, useEffect } from 'react';
import { getDocFileData } from '../services/docServices';
import {
  getFileBytesLocalForage,
  setFileBytesLocalForage
} from '../utils/localForageUtils';

export function useFileDataCache(docId) {
  const [fileData, setFileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isUnmounted = false;

    async function loadFile() {
      if (!docId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        // 1) Check localForage
        const cachedBytes = await getFileBytesLocalForage(docId);
        if (!isUnmounted && cachedBytes) {
          setFileData(cachedBytes);
          setLoading(false);
          return;
        }

        // 2) If not in localForage, fetch from server
        const arrayBuffer = await getDocFileData(docId);
        if (isUnmounted) return;

        const typedArray = new Uint8Array(arrayBuffer);
        // Store it in localForage for next time
        await setFileBytesLocalForage(docId, typedArray);

        if (!isUnmounted) {
          setFileData(typedArray);
          setLoading(false);
        }
      } catch (err) {
        if (!isUnmounted) {
          console.error('useFileDataCache error:', err);
          setError(err);
          setLoading(false);
          setFileData(null);
        }
      }
    }

    loadFile();

    return () => {
      isUnmounted = true;
    };
  }, [docId]);

  return { fileData, loading, error };
}


